<template>
<div id="page-carga_mv" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Solicitud de Manifestación de Valor - Mediante layout" class="elevation-1 px-5 py-3" >

                    <v-card-text>
                        <v-card-text>
                              <v-card-actions>
              <v-spacer></v-spacer>
                              <v-btn  dark small color="green darken-5" 
                                    @click="downloadLayoutAyuda('layout_manifestacion.xlsx')" v-tippy>
                                    <v-icon dark>mdi-table</v-icon>Descargar Layout
                               </v-btn>
                                     </v-card-actions>
                            <v-form ref="form" lazy-validation>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <v-text-field label="Selecciona el archivo Excel .xlsx" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                            <input type="file" style="display: none" ref="file_input" accept=".xlsx" @change="onFilePicked" >
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>


                        </v-card-actions>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>



    </v-container>
</div>
</template>

<script>
import axios from "axios";


export default {
    created: function () {
        this.cliente = this.$local_storage.get("id_cliente");
        //this.model.cliente = 52;
    },
    data() {
        return {
            fab: false,

            show_loading: false,
            breadcrumbs: [{
                    text: "Inicio",
                    to: "/home"
                },
         {
                text: "EManifiesto",
                to: "/manifestacion/transmitir"
            },
                {
                    text: "Carga Layout MV",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            modalApendice: false,
            apendice_items: [],
            columns: [
                "clave",
                "descripcion",
            ],

            update: false,

            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,
            type_file: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      //      type_file: 'application/zip',

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",

        };
    },

    methods: {

        pickFile() {
            this.$refs.file_input.click()
        },
 downloadLayoutAyuda: function (key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "descargas.econnectpro.mx"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            //a.download = name[name.length - 1];
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
        onFilePicked(e) {
            try {
                const files = e.target.files;

                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;

                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }

                    var nombre = this.name_file.split(".");
                    var split = [];
                        this.uploadFile(files[0], nombre[0]);
                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc_file = this.$local_storage.get("rfc");
            var usuario_file = this.$local_storage.get("id_usuario");
            var UID =  Math.floor(Math.random() * 9999999);
            var keyFile = rfc_file + "/mv_layouts/manifestaciones/" +  UID + "_" + this.name_file.toUpperCase();
            var thisObj = this;
            var datos = {
                key: keyFile,
                bucket: "sftp.econnectpro.mx",
                type: thisObj.type_file
            }


            axios.post(this.$hostname + 's3/upload_url/', datos)
                .then((res) => {
              //    console.log(res);
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                      //  console.log(urlput);
                        axios.put(urlput, file, {headers:{'Content-Type': this.type_file}})
                        .then((res) => {
                     //      console.log(res);
                             this.$swal({
                                  type: "success",
                                  title: "¡Operación Exitosa!",
                                  text: "El archivo se cargo correctamente y esta en proceso de importación.",
                                  footer: '',
                              });
                               this.$root.$dialogLoader.hide();
                                thisObj.$router.replace("/manifestacion/transmitir").catch(() => {});

                        })
                        .catch((error)=>{
                            this.$root.$dialogLoader.hide();
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                footer: '',
                            });
                            console.log(error);
                        });

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                            footer: '',
                        });
                         this.$root.$dialogLoader.hide();
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Favor de comunicarse con soporte.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                });
        },


        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },

    }
};
</script>
